export default class PublicationStatus {
    public static readonly Published = new PublicationStatus("Published", "Published", true);
    public static readonly Unpublished = new PublicationStatus("Unpublished", "Unpublished", false);

    private constructor(public readonly value: string, public readonly displayName: string, 
        public readonly isPublished: boolean) {
    }
}